angular.module('impactx.product').controller('ProductEditRelationsCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    '$redirect',
    'ToastService',
    'ProductSelectionService',
    'BackService',
    'ToolbarService',
    ProductEditRelationsCtrl
]);

function ProductEditRelationsCtrl($scope, $routeParams, dataGen, $redirect, ToastService, ProductSelectionService, BackService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {
        id: $routeParams.id,
        catId: $routeParams.catId
    }, "/product/checkout/getrelations").then(function () {
        $scope.data.deletedProductRelations = [];
        defineButtons();
    });

    self.save = function () {
        var dataObj = {
            relationData: $scope.data
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/product/checkout/saverelations").then(function () {
            BackService.back();
            ToastService.openStandardToast(tempScope.trns.saveSuccess);
        });
    };

    self.abort = function () {
        BackService.back();
    };

    self.addRelation = function () {
        var config = {
            title: $scope.trns.addRelation,
            locals: {
                checkOutCatId: $routeParams.catId
            }
        };
        ProductSelectionService.open(config).then(function (additionalProduct) {
            if (additionalProduct) {
                var tempRelation = JSON.parse(JSON.stringify($scope.data.templateRelation));
                tempRelation.targetProduct.name = additionalProduct.name;
                tempRelation.targetProduct.id = additionalProduct.id;
                $scope.data.productRelations.push(tempRelation);
            }
        });
    };

    self.deleteRelation = function (index) {
        $scope.data.deletedProductRelations.push($scope.data.productRelations.splice(index, 1)[0]);
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.abort,
                action: self.abort,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.addRelation,
                action: self.addRelation,
                type: 'dialogaction'
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}